/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState, useContext } from "react"
import TopHeader from "../../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import moment from "moment"
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useSelector,useDispatch } from 'react-redux'
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import { convertEpochToDateFormat } from "../../../CommonMethods/convertEpochToDateFormat"
import { useViewPatientQuery, useExportPatientNotesMutation } from '../../../slices/patientSlice'
import ViewPatientDetails from "./Components/ViewPatientDetails"
import ViewAdministartiveDetails from "./Components/ViewAdministrativeNotes"
import ViewMedicalNoteDetails from "./Components/ViewMedicalNotes"
import ViewPatientMoniteringCondition from "./Components/viewPatientMoniteringCondition"
import { handleEditMessageSent, handleSystemConfig } from "../../../redux/systemConfigSlice"
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideOrganizationQuery} from '../../../slices/patientSlice'
import { organizationusersList } from "../../../slices/apiSlice"
import { dataService } from "../../../services/data.services"

export default function ViewPatient() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { setToastmessage, setToastErrorMessage, isSideBar,sendMessageToStartEditing,editSocket } = useContext(GlobalContext)
    const [searchParams, setSearchParams] = useSearchParams()

    const location = useLocation();
    const [exportNotes] = useExportPatientNotesMutation()
    const [patientDetails, setViewPatientDetails] = useState("");
    const [notedetails, setViewNoteDetails] = useState([]);
    const [medicalNotes, setViewMedicalDetails] = useState([])
    const [loading, setLoading] = useState(true)
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const [patientTabName, setPatientTabName] = useState('patient')
    const [exportLoading, setExportLoading] = useState(false)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    const [notesCount, setNotesCount]=useState('0')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const { id } = useParams()
    const { data, isFetching, status } = useViewPatientQuery(`${id}?action=view`, { refetchOnMountOrArgChange: true })

    useEffect(() => {
        if (data !== undefined) {
            setViewPatientDetails(data[0])
            const administrativeNotes = data[0]?.notes || []; // Ensure notes array exists
            const notes = administrativeNotes
                ?.filter(item => item.note_type === "administrative-note") // Filter out only administrative notes
                ?.map(item => ({
                    administrative_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                    patient_id: item.patient_id || '',
                }));

            setViewNoteDetails(notes);
            const medicalNotes = data[0]?.notes || []; // Ensure notes array exists
            const medicalnote = medicalNotes
                ?.filter(item => item.note_type === "medical-note") // Filter out only administrative notes
                ?.map(item => ({
                    medical_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                }));

            setViewMedicalDetails(medicalnote);
        }
    }, [data])

    const handleTabChange = (tabName) => {
        setPatientTabName(tabName)
    }

    // export medical and administative notes
    //Administrative & Medical Notes Export
    async function handleExport(type) {
        let patientId = data[0].patient_id
        let noteType = type
        setExportLoading(true)

        let payload = { patientId, dateformat, noteType }
        const exportRes = await exportNotes(payload)
        setExportLoading(false)
        window.open(exportRes?.data.presigned_url)

        if (exportRes?.error) {
            setToastErrorMessage("Something went wrong")
        }
        else {
            setToastmessage(exportRes?.data?.message)
        }
    }

    const [isSafari, setIsSafari] = useState(false);
    useEffect(() => {
        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
    }, []);

    useEffect(() => {
        if (Array.isArray(location.state) && location?.state?.length === 1 && (!location?.state?.[0]?.includes('@'))) {
            handleTabChange(location?.state?.[0])
            navigate({
                state: {}
            });
        }
    }, [location])

    const handleEditButtonClick = () =>{
        if(!messageSent){
            sendMessageToStartEditing(data?.[0]?.patient_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    dispatch(organizationusersList.util.resetApiState())
                    navigate(`/manage-patients/edit-patient/${id}`,{state:{ ...location.state, fromScreen: 'view',true:true,id:id , patientTabName: patientTabName } })
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this patient`)
                    }
                }
            }    
        }
    }   
    
    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-view-patients');
        } else {
            setQueryParamsorg('type=org-user-view-patients');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    //const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat?.split(',')[0]} hh:mm:ss A`):moment(data?.data?.created_at).format(dateformat)
    const date = convertEpochToDateFormat(patientDetails?.created_at, dateformat)
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Patients"} />
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Patient Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-[22px]'>
                                    <Link to="/manage-patients" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>

                                    <h1 className="text-sm font-normal text-[#008586]">View Patient</h1>
                                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span> 
                                </div>
                                <div className="flex items-center pb-3 pr-9">
                                    <Link to={`/manage-patients`} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>
                                    <h1 className='text-xl font-normal text-[#000000] text-center w-full xl:-ml-[146px]'>
                                        View Patients
                                    </h1>
                                    <div className="xl:hidden block ml-4">
                                        <button
                                            onClick={handleEditButtonClick} 
                                            // onClick={() => { navigate(`/manage-patients/edit-patient/${id}`, { state: { ...location.state, fromScreen: 'view', patientTabName: patientTabName } }) }}
                                            id="edit" type='button' className={`min-w-max px-4 py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between items-center pl-[30px] xl:pr-11 pr-10">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]">{patientDetails?.last_name} {patientDetails?.first_name} {patientDetails?.middle_name}</p>
                                            <p className="text-sm font-normal text-[#000000] px-2">{patientDetails?.patient_id}</p>
                                            {patientDetails?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>
                                        <div className="flex items-center">
                                            <button type="button"
                                                id={'activity-log'}

                                                onClick={() => { navigate('/manage-patients/activity_history', { state: [patientDetails.user_name, true, id] }) }}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C]  min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] ml-2`}>
                                                View Activity Log
                                            </button>
                                            {(patientTabName === "administrative_notes" && notesCount!==0) &&
                                                <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("administrative-note")} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                                    {exportLoading ?
                                                        <div className='flex justify-center items-center'>
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                        </div>
                                                        : <img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }
                                            {(patientTabName === "medical_notes" && notesCount!==0) &&
                                                <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("medical-note")} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                                    {exportLoading ?
                                                        <div className='flex justify-center items-center'>
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                        </div>
                                                        : <img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }
                                            <div className="xl:block hidden ml-4">
                                                <button
                                                    onClick={handleEditButtonClick} 
                                                    id="edit" className={`min-w-max px-4 py-2 hover:bg-[#EDD7E1] border border-[#972E4C] h-fit rounded-[16px] flex items-center`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mx-7 mt-4'>
                                        <div className={`flex justify-between ${isSafari ? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari ? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6`}>
                                            <button onClick={() => { handleTabChange('patient') }} className={`px-2 pt-2.5 min-w-fit text-base font-semibold ${patientTabName === 'patient' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'patient' ? 'patient_tab' : ''}`}>
                                                Patient Details
                                            </button>
                                            <button id={'monitor_tab'} data-testid={'monitoring_conditions'} onClick={() => { handleTabChange('monitoring_conditions') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'monitoring_conditions' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'monitoring_conditions' ? 'patient_tab' : ''}`}>
                                                Monitoring Conditions
                                            </button>
                                            <button id={'administrative_notesTab'} onClick={() => { handleTabChange('administrative_notes') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'administrative_notes' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'administrative_notes' ? 'patient_tab' : ''}`}>
                                                Administrative Notes
                                            </button>
                                            <button id={'medical_notesTab'} onClick={() => { handleTabChange('medical_notes') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'medical_notes' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'medical_notes' ? 'patient_tab' : ''}`}>
                                                Medical Notes
                                            </button>
                                        </div>
                                    </div>
                                    {patientTabName === "patient" &&
                                        <ViewPatientDetails
                                            date={date}
                                            patientDetails={patientDetails}
                                        />}
                                    {patientTabName === "administrative_notes" && <ViewAdministartiveDetails
                                        patient_id={patientDetails?.patient_id}
                                        notesCount={notesCount} 
                                        setNotesCount={setNotesCount}

                                    />}
                                    {patientTabName === "medical_notes" && <ViewMedicalNoteDetails
                                        patient_id={patientDetails?.patient_id}
                                        notesCount={notesCount} 
                                        setNotesCount={setNotesCount}
                                    />}
                                    {patientTabName === 'monitoring_conditions' &&
                                        <ViewPatientMoniteringCondition
                                            date={date}
                                            patientDetails={patientDetails}
                                        />
                                    }

                                </div>
                            </div>
                            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                            <HelpGuideModal
                                setHelpGuideModel={setHelpGuideModel}
                                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }

                        </motion.div>
                    </div>
                </>}
            </div>
        </>
    )
}